import React from 'react';
import { TrackingProviderV2 } from '@givelify/utils';
import { Grid } from '@mui/material';
import { GivelifyButton } from '../button';
import { GivelifyIcon } from '../icon';
import { GivelifyLabel } from '../label';
import { DesignTokens } from '../specify';
import { ContentContainer, StyledModal } from './style';

export type ConfirmModalProps = {
    open: boolean;
    title: string;
    description: string;
    confirmText: string;
    cancelText: string;
    onConfirm: () => void;
    onCancel: () => void;
    name: string;
    className?: string;
    cancelAsPrimary?: boolean;
};
export const ConfirmModal: React.FCC<ConfirmModalProps> = ({
    open,
    title,
    description,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    name,
    className,
    cancelAsPrimary,
}) => {
    return (
        <StyledModal
            showCloseButton
            className={className}
            name={name}
            onClose={onCancel}
            open={open}
            trackingProvider={TrackingProviderV2}
        >
            <ContentContainer>
                <GivelifyIcon className="modal-icon" variant="alert" />
                <GivelifyLabel
                    text={title}
                    textAlign="center"
                    variant="heading2S"
                />
                <GivelifyLabel
                    className="description"
                    color={DesignTokens.color.textSecondary}
                    text={description}
                    variant="body1"
                />

                <Grid
                    container
                    alignItems="center"
                    className="modal-actions"
                    justifyContent="space-around"
                >
                    <GivelifyButton
                        onClick={onCancel}
                        size="large"
                        text={cancelText}
                        variant={cancelAsPrimary ? 'primary' : 'secondary'}
                    />
                    <GivelifyButton
                        onClick={onConfirm}
                        size="large"
                        text={confirmText}
                        variant={cancelAsPrimary ? 'secondary' : 'primary'}
                    />
                </Grid>
            </ContentContainer>
        </StyledModal>
    );
};
